module.exports = __webpack_public_path__ + "img/ic_64_feature_wettbewerbe.4ceccfba.svg";